const moment = require( 'moment' );
import { User } from "./User";

export class CurrentUser extends User
{
    constructor( props )
    {
        super( props );
    }

    isPaying()
    {
        return ( true === this.hasActiveMembershipPlan() && true === this.hasActiveMotivationBonusPlan() );
    }

    hasActiveMembershipPlan()
    {
        const planId = this.getData( 'membershipPlanId', null );
        return planId && planId.length > 0 ? true : false;
    }

    hasActiveMotivationBonusPlan()
    {
        const planId = this.getData( 'motivationBonusPlanId', null );
        return ( planId && planId.length > 0);
    }

    getMomentCreated()
    {
        return moment( this.get( '_createdAt' ) );
    }
}
